import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { DividerComponent } from '../divider/divider.component';
import { HeadlineComponent } from '../headline/headline.component';
import { IconModule } from '../icon/icon.module';
import { MobileSubNavListEntryComponent } from '../mobile-sub-nav-list-entry/mobile-sub-nav-list-entry.component';
import { NavListModule } from '../nav-list/nav-list.module';
import { TagComponent } from '../tag/tag.component';
import { TooltipModule } from '../tooltip/tooltip.module';
import { AppBackgroundPipe } from './app-nav/app-background-pipe/app-background.pipe';
import { AppNavComponent } from './app-nav/app-nav.component';
import { MobileAppNavComponent } from './mobile-app-nav/mobile-app-nav.component';
import { MobileNavComponent } from './mobile-nav/mobile-nav.component';
import { NavComponent } from './nav/nav.component';
import { SubNavComponent } from './sub-nav/sub-nav.component';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		IconModule,
		MatIconModule,
		NavListModule,
		TooltipModule,
		HeadlineComponent,
		DividerComponent,
		MobileSubNavListEntryComponent,
		TagComponent,
		AppBackgroundPipe,
	],
	declarations: [
		MobileNavComponent,
		NavComponent,
		AppNavComponent,
		SubNavComponent,
		MobileAppNavComponent,
	],
	exports: [
		MobileNavComponent,
		NavComponent,
		AppNavComponent,
		SubNavComponent,
		MobileAppNavComponent,
	],
})
export class NavModule {}
